export interface ShortcutDescriptor {
  key: string;
  name: string;
  id: string;
  description: string;
}

export const SHORTCUTS = {
  POS: {
    FOCUS_SEARCH: {
      key: "ctrl",
      name: "Ctrl",
      id: "pos_focus_search",
      description: "Focus Product Search Bar",
    },
    SELECT_CART: {
      key: "ctrl+shift",
      name: "Ctrl+Shift",
      id: "pos_select_cart",
      description: "Activate Cart Navigation",
    },
    DELETE_CART_ITEM: {
      key: "delete",
      name: "Delete",
      id: "pos_delete_cart_item",
      description: "Delete selected cart item",
    },
    CYCLE_BATCH: {
      key: "shift",
      name: "Shift",
      id: "pos_cycle_batch",
      description: "Cycle Selected Stock Batch",
    },
    QTY_UP: {
      key: "up",
      name: "Up",
      id: "pos_qty_up",
      description: "Increase Custom Qty",
    },
    QTY_DOWN: {
      key: "down",
      name: "Down",
      id: "pos_qty_down",
      description: "Decrease Custom Qty",
    },
    FOCUS_PRICE: {
      key: "alt",
      name: "Alt",
      id: "pos_focus_price",
      description: "Focus Custom Price Input",
    },
    SELECT_PRODUCT_FROM_SEARCH: {
      key: "enter",
      name: "Enter",
      id: "pos_select_product_from_search",
      description: "Select product from search",
    },
    ADD_PRODUCT_TO_CART: {
      key: "enter",
      name: "Enter",
      id: "pos_add_product_to_cart",
      description: "Add Selected Product to Cart",
    },
    DISCARD_PRODUCT: {
      key: "delete",
      name: "Delete",
      id: "pos_discard_product",
      description: "Discard Selected Product",
    },
    CART_NEXT: {
      key: "down",
      name: "Down",
      id: "pos_cart_next",
      description: "Move to Next Item",
    },
    CART_PREVIOUS: {
      key: "up",
      name: "Up",
      id: "pos_cart_previous",
      description: "Move to Previous Item",
    },
    CART_REMOVE: {
      key: "delete",
      name: "Delete",
      id: "pos_cart_remove",
      description: "Remove Item from Cart",
    },
    CART_REMOVE_BACKSPACE: {
      key: "backspace",
      name: "Backspace",
      id: "pos_cart_remove_backspace",
      description: "Remove Item from Cart",
    },
    CART_EDIT: {
      key: "enter",
      name: "Enter",
      id: "pos_cart_edit",
      description: "Edit Selected Item Qty/Price",
    },
    CART_CLOSE: {
      key: "esc",
      name: "Esc",
      id: "pos_cart_close",
      description: "Deactivate Cart Navigation",
    },
    PAY_CASH: {
      key: "f1",
      name: "F1",
      id: "pos_pay_cash",
      description: "Open Pay Checkout Drawer",
    },
    RETURN_DRAWER: {
      key: "f2",
      name: "F2",
      id: "pos_return_drawer",
      description: "Open Order Return Drawer",
    },
    EXPENSE_DRAWER: {
      key: "f3",
      name: "F3",
      id: "pos_expense",
      description: "Open Expense Drawer",
    },
    TOGGLE_DRAWER: {
      key: "esc",
      name: "Esc",
      id: "pos_toggle_drawer",
      description: "Toggle Quick Actions Drawer",
    },
    NAVIGATE_TO_POS: {
      key: "tab",
      name: "Tab+Tab",
      id: "pos_navigate_to_pos",
      description: "Navigate to pos",
    },
    SAVE_DRAFT: {
      key: "ctrl+s",
      name: "Ctrl+S",
      id: "pos_save_draft",
      description: "Direct Save Draft Cart",
    },
    SAVE_QUOTATION: {
      key: "ctrl+q",
      name: "Ctrl+Q",
      id: "pos_save_quotation",
      description: "Direct Save Quotation",
    },
  },
  PRODUCTS: {
    FOCUS_SEARCH: {
      key: "ctrl",
      name: "Ctrl",
      id: "prod_focus_search",
      description: "Focus products list search bar",
    },
  },
  CHECKOUT: {
    CYCLE_PAYMENT: {
      key: "shift",
      name: "Shift",
      id: "drawer_cycle_payment",
      description: "Cycle Payment Mode",
    },
    TOGGLE_CREDIT: {
      key: "alt",
      name: "Alt",
      id: "drawer_toggle_credit",
      description: "Toggle Credit Sale",
    },
    CONFIRM_SALE: {
      key: "enter",
      name: "Enter+Enter",
      id: "drawer_confirm_sale",
      description: "Confirm & Process Transaction",
    },
    CLOSE_DRAWER: {
      key: "esc",
      name: "Esc",
      id: "drawer_close",
      description: "Close Checkout Drawer",
    },
  },
  DRAFTS: {
    NAVIGATE_UP: {
      key: "up",
      name: "Up",
      id: "pos_drawer_draft_up",
      description: "Navigate drawer drafts up",
    },
    NAVIGATE_DOWN: {
      key: "down",
      name: "Down",
      id: "pos_drawer_draft_down",
      description: "Navigate drawer drafts down",
    },
    RESTORE: {
      key: "enter",
      name: "Enter",
      id: "pos_drawer_draft_enter",
      description: "Restore drawer selected draft",
    },
  },
  INVOICE_PRINT: {
    DOWNLOAD_PDF: {
      key: "p",
      name: "P",
      id: "download_invoice_pdf",
      description: "Download invoice as PDF",
    },

    PRINT_INVOICE: {
      key: "enter",
      name: "Enter",
      id: "print_invoice_pdf",
      description: "Print invoice",
    },

    CHANGE_TEMPLATE: {
      key: "t",
      name: "T",
      id: "change_invoice_template",
      description: "Cycle or open template dropdown",
    },

    CHANGE_PAGE_SIZE: {
      key: "s",
      name: "S",
      id: "change_invoice_page_size",
      description: "Cycle or open page size dropdown",
    },
  },
};
